module.exports = __webpack_public_path__ + "img/chinese_2.63a39848.png";